import $ from 'jQuery';

export default function () {
    var current_page = 1;

    $(function() {

        if ($('#filter-branches').length > 0) {
            // Fetch first 9 events
            fetchEvents();

            // Iterate over each element in case there are several blocks
            var filterBranchesSelector = $('#filter-branches');
            filterBranchesSelector.each(function() {
                // Add an event listener for the 'click' event
                this.addEventListener('change', function() {
                    fetchEvents(1);
                });
            });

            // Set function to each category filter button if any
            $('.btn-category-filter').each(function() {
                $(this).on('click', function() {
                    $('.btn-category-filter').removeClass('active');
                    $(this).addClass('active');
                    $('#filter-category').val($(this).attr('data-attr'));
                    fetchEvents(1);
                });
            });
        }

        $('#categoriesMobileOnly').on('change',function() {
            // $(this).parent().find('a[data-attr="' + $(this).find(':selected').val() + '"]').trigger('click');
            $('#filter-category').val($(this).val());
            fetchEvents(1);
        });
    });

    function fetchEvents(page_number) {

        $('.spinner').addClass('loading');
        $('.featured-branch-events--cards').html('');
        $('.featured-branch-events--pagination').html('');

        // AJAX call
        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            method: 'POST',
            data: {
                action: 'ajax_fetch_events',
                branch: $('#filter-branches').val(),
                category: $('#filter-category').val(),
                paged: page_number
            }, success: function (response) {

                if (response && response.success) {
                    // Add new content
                    if (response.data.count > 0) {

                        $('.featured-branch-events--cards').html(response.data.html);
                        $('.featured-branch-events--pagination').html(response.data.pagination);

                        // Modify pagination links
                        $('.featured-branch-events--pagination a.page-numbers').each(function() {
                            if (!$(this).hasClass('disabled')) {
                                $(this).attr('href', 'javascript: void(0);');

                                $(this).on('click', function() {
                                    if ($(this).text() > 0) {
                                        fetchEvents($(this).text());
                                    } else if ($(this).hasClass('prev')) {
                                        fetchEvents(page_number-1);
                                    } else if ($(this).hasClass('next')) {
                                        fetchEvents(page_number+1);
                                    }
                                });
                            }
                        });
                    } 

                    // Hide loading
                    $('.spinner').removeClass('loading');

                }
            }, error: function (error) {
                // Hide loading
                $('.spinner').removeClass('loading');
            }
        });
    }
}
